<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="selector-wrapper">
    <section class="selector-body">
      <van-form ref="form">
        <van-field
          v-model="model.ownerOrgName"
          name="ownerOrgName"
          label="驻地监测单位"
          :rules="[{required:true,message:'请填写驻地监测单位'}]"
        />
        <van-field
          v-model="model.siteAddress"
          name="siteAddress"
          label="站房地址"
          :rules="[{required:true,message:'请填写站房地址'}]"
        />
      </van-form>
    </section>

    <section class="selector-footer">
      <button v-if="taskNum > 1" class="back-btn" @click="onPreStepClick">返回站房选择</button>
      <Abort />
      <button class="next-btn" @click="onNextStepClick">下一步</button>
    </section>
  </section>
</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'index',
  routeInfo: {
    label: '站房信息'
  },
  data () {
    return {
      model: {
        siteAddress: '',
        ownerOrgName: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      task: 'Task/task',
      taskNum: 'Task/taskNum'
    })
  },
  methods: {
    onPreStepClick () {
      this.save(() => {
        this.$router.replace({
          name: 'SiteSelector'
        })
      })
    },
    onNextStepClick () {
      this.save(() => {
        this.$router.replace({
          name: 'MaintainOrgSelector'
        })
      })
    },
    save (callback) {
      let {task, model} = this

      this.$refs.form.validate().then(() => this.$api.Site.update({
        taskId: task.id,
        id: task.siteId,
        address: model.siteAddress,
        orgNames: model.ownerOrgName,
        orgId: task.ownerOrgId
      })).then(() => {
        task.ownerOrgName = model.ownerOrgName
        callback()
      }).catch(console.error)
    }
  },
  created () {
    let {task, model} = this
    model.ownerOrgName = task.ownerOrgName

    this.$api.Site.getDetail(task.siteId).then(site => {
      model.siteAddress = site.address
    }).catch(console.error)
  }
}
</script>

<style lang="scss" scoped>
.selector-wrapper {
  .selector-body {
    padding: 1rem;
    border-bottom: 1px solid #cfd0d3;
    background-color: #f7f8fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02SiteInfo/index.vue